import { useState } from 'react';
import { IMAGE_URL } from '../../../config/global.config';
import useAuth from '../../../hooks/useAuth';
import { toast } from '../../../lib/toast';
import { uploadFile } from '../../../utils/upload';

/**
 * Uploads one file through the shared upload API and returns its public URL
 * (same URL shape as the shared PhotoUploader / FileUploader), or null.
 */
const useFileUpload = (maxMb = 5) => {
  const { access_token } = useAuth();
  const [uploading, setUploading] = useState(false);

  const upload = async (file: File) => {
    if (file.size > maxMb * 1024 * 1024) {
      toast('error', `"${file.name}" exceeds ${maxMb} MB`);
      return null;
    }
    setUploading(true);
    try {
      const res = await uploadFile(file, access_token as string);
      if (res.success && res.fileUrl) return `${IMAGE_URL}/${res.fileUrl}`;
      toast('error', `File upload failed: ${file.name}`);
      return null;
    } catch {
      toast('error', `File upload failed: ${file.name}`);
      return null;
    } finally {
      setUploading(false);
    }
  };

  return { upload, uploading };
};

export default useFileUpload;
